import {createRouter, createWebHashHistory} from 'vue-router'
const routes = [
  {
    path: '/',
    component: () => import('@/views/homePage/homePage.vue'),
    name: 'Home_1',
    meta: { title: '首页' },
  },
  {
    path: '/templateone/:id',
    component: () => import('@/views/template/template_one.vue'),
    name: 'templateone',
    meta: { title: '首页' },
  },
  {
    path: '/enroll',
    component: () => import('@/views/baoming/baoMingPage.vue'),
    name: 'baoming_1',
    meta: { title: '报名' },
  },
  {
    path: '/home',
    component: () => import('@/views/homePage/homePage.vue'),
    name: 'home',
    meta: { title: '首页' },
  },
  {
    path: '/Information',
    component: () => import('@/views/Layout/realTimeInfo.vue'),
    name: 'Information',
    meta: { title: '资讯' },
  },
  {
    path: '/Community',
    component: () => import('@/views/community/communityPage.vue'),
    name: 'Community',
    meta: { title: '社区' },
  },
  {
    path: '/cooperation',
    component: () => import('@/views/cooperation/cooperationPage.vue'),
    name: 'cooperation',
    meta: { title: '合作' },
  },
  {
    path: '/comprehensive',
    component: () => import('@/views/comprehensive/comprehensivePage.vue'),
    name: 'comprehensive',
    meta: { title: '综合课程'},
    
  },
  {
    path: '/aicourse',
    component: () => import('@/views/aiCourse/aiCourse.vue'),
    name: 'aicourse',
    meta: { title: 'AI课程' },
  },
  {
    path: '/FAQ',
    component: () => import('@/views/faqPage/faqPage.vue'),
    name: 'FAQ',
    meta: { title: '常见问题' },
  },
  {
    path: '/gamecourse',
    component: () => import('@/views/gameCourse/gameCourse.vue'),
    name: 'gamecourse',
    meta: { title: '游戏课程' },
  },
  {
    path: '/case',
    component: () => import('@/views/case/casePage.vue'),
    name: 'case',
    meta: { title: '案例' },
  },
  {
    path: '/service',
    component: () => import('@/views/service/servicePage.vue'),
    name: 'service',
    meta: { title: '服务' },
  },
]
const router= createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的滚动位置，则使用保存的位置
  
    if (savedPosition) {
      return savedPosition;
    } else {
      // 否则，滚动到顶部
      return { left: 0, top: 0 };
    }
    
  },
})
router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title; // 设置页面标题
  }
  next();
});
export default router;